import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchProviderSpecialOrders = (providerCode, orderType) => {
  const providerCodeFilter = providerCode ? `&provider=${providerCode}` : '';
  const orderTypeFilter = orderType ? `&orderType=${orderType}` : '';

  return apiActionCreator({
    'endpoint': `/orders/providers/specials?${providerCodeFilter}${orderTypeFilter}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PROVIDER_SPECIAL_ORDERS,
      ActionTypes.FETCHED_PROVIDER_SPECIAL_ORDERS,
      [
        ActionTypes.FETCHED_PROVIDER_SPECIAL_ORDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const generateTxtForProviderSpecialOrders = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/providers/specials',
      'authenticated': true,
      'types': [
        ActionTypes.GENERATING_TXT_FOR_PROVIDER_SPECIAL_ORDERS,
        [
          () => {
            dispatch(fetchProviderSpecialOrders(data.provider, data.orderType));
            return {
              'type': ActionTypes.GENERATED_TXT_FOR_PROVIDER_SPECIAL_ORDERS,
            };
          },
          () =>
            MessageActions.addMessageBoxInfo(
              'Se ha generado exitosamente el archivo TXT'
            ),
        ],
        [
          ActionTypes.GENERATED_TXT_FOR_PROVIDER_SPECIAL_ORDERS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const askForProviderSpecialOrderAuthorization = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/providers/specials',
      'authenticated': true,
      'types': [
        ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_REQUEST,
        [
          () => {
            dispatch(fetchProviderSpecialOrders(data.provider, data.orderType));
            return {
              'type': ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_SUCCESS,
            };
          },
          MessageActions.addMessageBoxInfo(
            'El pedido ha iniciado el flujo de autorización.'
          ),
        ],
        [
          ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const rejectProviderSpecialOrder = (index, data) =>
  apiActionCreator({
    'endpoint': '/orders/providers/specials',
    'authenticated': true,
    'types': [
      ActionTypes.REJECTING_PROVIDER_SPECIAL_ORDERS,
      [
        {
          'type': ActionTypes.REJECTED_PROVIDER_SPECIAL_ORDERS,
          'payload': index,
        },
        (response) => MessageActions.addMessageBoxInfo(response.data),
      ],
      [
        ActionTypes.REJECTED_PROVIDER_SPECIAL_ORDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
    'contentType': 'application/json',
    'data': data,
  });

export const updateTransport = (index, value) => ({
  'type': ActionTypes.CHANGE_TRANSPORT_OPTIONS,
  'payload': {index, value},
});

export const toggleMarkInSpecialOrders = (index) => ({
  'type': ActionTypes.TOGGLE_MARK_IN_PROVIDER_SPECIAL_ORDER,
  'payload': index,
});

export const toggleAllProviderSpecialOrders = () => ({
  'type': ActionTypes.TOGGLE_ALL_PROVIDER_SPECIAL_ORDERS,
});
